import type { ProjectCategory, ProjectStatus, ProjectType } from '@/types/project';

export const PROJECT_STATUS = {
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED',
} as const satisfies Record<string, ProjectStatus>;

export const PROJECT_STATUS_LABELS: Record<ProjectStatus, string> = {
  ACTIVE: '进行中',
  ARCHIVED: '已归档',
};

export const PROJECT_TYPE = {
  PROVINCIAL_KEY: 'PROVINCIAL_KEY',
  MUNICIPAL_KEY: 'MUNICIPAL_KEY',
  ENGINEERING: 'ENGINEERING',
  INVESTMENT: 'INVESTMENT',
  KEY_PROJECT: 'KEY_PROJECT',
  TEMPORARY: 'TEMPORARY',
  OTHER: 'OTHER',
} as const satisfies Record<string, ProjectType>;

export const PROJECT_TYPE_LABELS: Record<ProjectType, string> = {
  PROVINCIAL_KEY: '省重点项目',
  MUNICIPAL_KEY: '市重点项目',
  ENGINEERING: '工程类',
  INVESTMENT: '投资类',
  KEY_PROJECT: '重点项目',
  TEMPORARY: '临时项目',
  OTHER: '其他',
};

export const PROJECT_CATEGORY = {
  PROVINCIAL_KEY_ENGINEERING: 'PROVINCIAL_KEY_ENGINEERING',
  MUNICIPAL_KEY_ENGINEERING: 'MUNICIPAL_KEY_ENGINEERING',
  INDUSTRIAL: 'INDUSTRIAL',
  INFRASTRUCTURE: 'INFRASTRUCTURE',
  LIVELIHOOD: 'LIVELIHOOD',
  SIGNED_PROJECT: 'SIGNED_PROJECT',
  PROPOSED_SIGNING_PROJECT: 'PROPOSED_SIGNING_PROJECT',
} as const satisfies Record<string, ProjectCategory>;

export const PROJECT_CATEGORY_LABELS: Record<ProjectCategory, string> = {
  PROVINCIAL_KEY_ENGINEERING: '省重点工程项目',
  MUNICIPAL_KEY_ENGINEERING: '市重点工程项目',
  INDUSTRIAL: '产业项目',
  INFRASTRUCTURE: '基础设施项目',
  LIVELIHOOD: '民生项目',
  SIGNED_PROJECT: '已签约项目',
  PROPOSED_SIGNING_PROJECT: '拟签约项目',
};

export const PROJECT_CATEGORY_OPTIONS = Object.entries(PROJECT_CATEGORY_LABELS).map(
  ([value, label]) => ({ value, label }),
);
